<template>
  <div class="content layer">
    <ticket-header :title='headerTitle' :description="headerDescription"/>
    <div class="ticketCon">
      <div class="flexTbl">
        <dl class="full">
          <dt>期間指定</dt>
          <dd>
            <ticket-list-time-picker
                :startDate="startDate"
                :endDate="endDate"
                :updateDate="updateDate"
                :page-type="type"
                :dateBtn="dateBtn"
            ></ticket-list-time-picker>
            <v-btn-toggle v-model="dateBtn" class="UXbtnToggle date-picker-btn">
              <v-btn flat @click="changStartData(0, 'days')" value="0" :disabled="dateBtn === '0'">
                <span>今日</span>
              </v-btn>
              <v-btn flat @click="changStartData(7, 'days')" value="6" :disabled="dateBtn === '6'">
                <span>7日</span>
              </v-btn>
              <v-btn flat @click="changStartData(1, 'month')" value="30" :disabled="dateBtn === '30'">
                <span>1ヶ月</span>
              </v-btn>
              <v-btn flat @click="changStartData(3, 'month')" value="90" :disabled="dateBtn === '90'">
                <span>3ヶ月</span>
              </v-btn>
              <v-btn flat @click="changStartData(6, 'month')" value="180" :disabled="dateBtn === '180'">
                <span>6ヶ月</span>
              </v-btn>
              <v-btn flat @click="changStartData(-1, 'ALL')" value="-1" :disabled="dateBtn === '-1'">
                <span>全体</span>
              </v-btn>
            </v-btn-toggle>
          </dd>
        </dl>
        <dl class="full">
          <dt>チャネル</dt>
          <dd>
            <ticket-check-channel ref="ticketCheckChannel" :page-type="type" :updateOption="updateOption" :disable-option="disableOption" />
          </dd>
        </dl>
        <dl>
          <dt>チケット状態</dt>
          <dd>
            <ticket-check-status ref="ticketCheckStatus" :page-type="type" :updateOption="updateOption" :disable-option="disableOption" />
          </dd>
        </dl>
        <dl>
          <dt>優先順位</dt>
          <dd>
            <ticket-check-first ref="ticketCheckFirst" :page-type="type" :updateOption="updateOption" :disable-option="disableOption" />
          </dd>
        </dl>

        <dl class="stretch1280" v-if="callMode === 'KT'">
          <dt>サービス名</dt>
          <dd>
            <ticket-service-select ref="ticketServiceSelectRef" :page-type="type" :updateOption="updateOption" :selectedService="selectedService" :isServiceSelectable="isServiceSelectable"></ticket-service-select>
          </dd>
        </dl>
        <dl :class="{'stretch1280': callMode === 'KT', 'full': callMode !== 'KT'}">
          <dt>分類カテゴリ</dt>
          <dd>
            <div class="counselTaskBox">
              <div class="selectBox" v-show="taskAuto">
                <ticket-counsel-type
                  ref="ticketCounselTypeRef"
                  :updateMajorTaskType="updateMajorTaskType"
                  :updateMiddleTaskType="updateMiddleTaskType"
                  :updateMinorTaskType="updateMinorTaskType"
                  :page-type="type"
                ></ticket-counsel-type>
              </div>
              <div class="selectBox selectEll" v-show="!taskAuto">
                <v-autocomplete
                  attach
                  v-model="taskTypeId"
                  class="UXautocomplete UXselect outline"
                  :menu-props="{ contentClass: 'UXautoMenu' }"
                  :items="brandCounselViewList"
                  item-text="counselTypeLine"
                  item-value="taskTypeId"
                  label="分類カテゴリ全体検索"
                  no-data-text="該当分類カテゴリは存在しません。"
                  hide-details
                  solo
                  outline
                ></v-autocomplete>
              </div>
              <div class="changeBtn">
                <v-btn outline large class="UXbtn" :disabled="initTicketList" @click="changeTaskType">
                  <i class="UXicon-transfer"></i>
                </v-btn>
              </div>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>チケット検索</dt>
          <dd>
            <search-ticket-keyword ref="searchTicketKeywordRef" :page-type="type" :updateOption="updateOption" :isLoading="isLoading"></search-ticket-keyword>
          </dd>
        </dl>
        <dl>
          <dt>タグ検索</dt>
          <dd class="autoCompBox">
            <tag-search-auto-complete
              ref="tagSearchAutoCompleteRef"
              :page-type="type"
              :placeholder="type === 'ALL_PAGE' || type === 'MY_PAGE' ? 'タグ入力' : 'タグ検索'"
              :brand-id="currentTicketBrandId"
              :updateSelectedTags="updateSelectedTags"
              size="large"
            />
          </dd>
        </dl>
        <dl>
          <dt>担当者</dt>
          <dd class="autoCompBox">
            <agent-select ref="agentSelectRef" :page-type="type" :agentSelectable="agentSelectable" :updateAgent="updateAgent" :ticketAgentId="ticketAgentId"/>
          </dd>
        </dl>
        <dl>
          <dt>顧客検索</dt>
          <dd>
            <search-customer-keyword ref="searchCustomerKeywordRef" :page-type="type" :isLoading="isLoading" :updateOption="updateOption"></search-customer-keyword>
          </dd>
        </dl>
      </div>
      <div class="cenBtn">
        <v-btn
          @click="resetAllOptions"
          class="UXbtn header-btn left-btn"
          outline
        >
          初期化
        </v-btn>
        <v-btn
          @click="updateOption('search')"
          class="UXbtn left-btn"
          color="#ff8c8c"
          dark
          small
        >
          検索
        </v-btn>
      </div>
      <div class="listBox">
        <div class="listHeader">
          <div class="left">
            <p>チケット ({{pagination.totalItems}})</p>
          </div>
          <div class="right">
            <excel-download-button
              :excelButtonDisabled="excelButtonDisabled"
              :isExcelDownloading="isExcelDownloading"
              :excel-download="validateExcelDownload"
              :disabled="!isPermission['export'] || isFuncLv1"
            ></excel-download-button>
            <v-select
              item-value="code"
              item-text="name"
              v-model="ticketSize"
              :items="showTicketNumbers"
              @change="ticketNumberChange"
              class="UXselect sizeWid ml-10"
              hide-details
              outline
              solo
              no-data-text="データがありません。"
            ></v-select>
          </div>
        </div>
        <div class="feature-box">
          <div class="feature-box-item">
            <delete-button
              :callAllTicketList="callAllTicketList"
              :deleteTargetTicket="!isPermission['delete'] ? [] : selectedTicket"
            />
            <batch-button
              :call-all-ticket-list="callAllTicketList"
              :batch-target-tickets="!isPermission['update'] ? [] : selectedTicket"/>
            <merge-button
              :mergeTargetTicket="!isPermission['merge'] ? [] : selectedTicket"
            ></merge-button>
            <merge-ticket-dialog
              :selectedTicket="selectedTicket"
              :mergeTicketDialog="mergeTicketDialogOpen"
              :close="closeMergeDialog"/>
          </div>
          <div class="feature-box-item">
            <add-new-ticket-button :disabled="!isPermission['create']"></add-new-ticket-button>
          </div>
        </div>
        <ticket-show-list
          ref="ticketShowListRef"
          :onCheckBoxChanged="onCheckBoxChanged"
          :pagination="pagination"
          :changePage="callAllTicketList"
          :datas="datas"
          :errorCode="errorCode"
          :isTicketRefresh="ticketRefresh"
          :headers="headers"
          :onPageSizeChanged="onPageSizeChanged"
          :open-header-customize-dialog="openHeaderCustomizeDialog"
          :order="order"
          :ascending="ascending"
          :updateTicketListOption="updateTicketListOption"
          @input="getPageList"
        ></ticket-show-list>
      </div>
    </div>
    <excel-password-dialog v-model="excel" :excel-download="excelDownload"></excel-password-dialog>
  </div>
</template>

<script>
import brandSelect from '../../../../../brand_select'
import mergeTicketDialog from './merge_ticket_dialog'
import ticketShowList from './ticket_show_list'
import TicketListUtil from '../../../util/ticket_list_util'
import ticketHeader from './ticket_header'
import ExcelDownloadButton from '../button/excelDownloadButton'
import DeleteButton from '../button/deleteButton'
import batchButton from '../button/batch_button'
import MergeButton from '../button/mergeButton'
import addNewTicketButton from '../button/addNewTicketButton'
import AgentSelect from '../layout/agent_select'
import TicketListTimePicker from '../layout/ticket_list_time_picker'
import ticketCounselType from '../layout/ticket_counsel_type'
import moment from 'moment'
import PageType from '../../../enums/pageType'
import OptionType from '../../../enums/ticketListOptionType'
import TagSearchAutoComplete from '../layout/tag_search_auto_complete'
import TicketHeaderCustomizeDialog from '../layout/ticket_header_customize_dialog'
import {mapGetters} from 'vuex'
import eventType from '@/components/menus/ticket/enums/eventType'
import eventBus from '@/event_bus'
import helper from 'util/helpers'
import searchCustomerKeyword from '../input/search_customer_keyword'
import searchTicketKeyword from '../input/search_ticket_keyword'
import ticketCheckChannel from './ticket_check_channel'
import ticketCheckStatus from './ticket_check_status'
import ticketCheckFirst from './ticket_check_first'
import ticketSelectOption from './ticket_select_option'
import ticketServiceSelect from './ticket_service_select'
import excelPasswordDialog from '@/components/dialog/excel_password_dialog'
import permissions from '@/util/permissions'
import util from '@/util'

export default {
  props: {
    disableOption: {
      type: String,
      default: ''
    },
    headerTitle: String,
    headerDescription: String,
    showAgentSelect: {
      type: Boolean,
      default: true
    },

    type: String
  },
  data: () => ({
    tipDialog: false,
    pagination: {
      page: 1
    },
    resultCount: 0,
    headers: [
      {text: 'チャネル', width: 80},
      {text: '優先順位', width: 80},
      {text: 'チケット状態', width: 150},
      {text: 'ID / タイトル / カテゴリ', width: 250},
      {text: 'サービス名', width: 129},
      {text: '顧客名 / 電話番号', width: 200},
      {text: '担当者', width: 80},
      {text: '受付日時', width: 100},
      {text: '更新日時', width: 100},
      {text: 'メモ', width: 120},
      {text: 'タグ', width: 120}
    ],
    datas: [],
    incomingSelected: [],
    statusSelected: [],
    prioritySelected: [],
    deleteButtonDisable: true,
    mergeButtonDisable: true,
    mergeTicketDialogOpen: false,
    selectedTicket: [],
    startDate: '',
    endDate: '',
    showAgentIds: [],
    agentSelectable: true,
    ticketSize: 15,
    selectedTags: [],
    isHeaderCustomizeDialogOpen: false,
    majorTask: null,
    minorTask: null,
    middleTask: null,
    ticketKeyword: null,
    customerKeyword: null,
    selectedService: null,
    serviceList: [],
    isExcelDownloading: false,
    excelButtonDisabled: true,
    taskAuto: false,
    showTicketNumbers: [
      {name: '15個', code: 15},
      {name: '30個', code: 30},
      {name: '50個', code: 50},
      {name: '100個', code: 100}
    ],
    order: 'modifyDate',
    ascending: false,
    dateBtn: '-1',
    excel: {
      excelComment: '',
      password: '',
      passwordConfirm: ''
    },
    keyList: ['merge', 'create', 'update', 'delete', 'export'],
    pmsKey: {
      merge: 'MERGE_TICKET',
      create: 'CREATE_TICKET',
      update: 'UPDATE_TICKET',
      delete: 'DELETE_TICKET',
      export: 'EXPORT_TICKET_LIST'
    },
    isPermission: {
      merge: false,
      create: false,
      update: false,
      delete: false,
      export: false
    },
    brandId: '',
    isLoading: false,
    errorCode: 0,
    ticketRefresh: false,
    isServiceSelectable: false,
    taskTypeId: null,
    brandCounselViewList: [],
    initTicketList: false
  }),
  components: {
    ticketCheckChannel,
    ticketCheckStatus,
    ticketCheckFirst,
    batchButton,
    DeleteButton,
    ExcelDownloadButton,
    brandSelect,
    mergeTicketDialog,
    ticketShowList,
    ticketSelectOption,
    ticketHeader,
    MergeButton,
    AgentSelect,
    TicketListTimePicker,
    addNewTicketButton,
    ticketCounselType,
    TagSearchAutoComplete,
    TicketHeaderCustomizeDialog,
    searchCustomerKeyword,
    searchTicketKeyword,
    excelPasswordDialog,
    ticketServiceSelect
  },
  watch: {
    startDate () {
      this.checkDate()
    },
    endDate () {
      this.checkDate()
    },
    currentTicketBrandId () {
      this.searchCounselTypes()
    },
    taskTypeId (val) {
      this.updateTicketListOption('taskTypeId', val)
      if (this.currentTicketBrandId) {
        this.getTicketList(1, true)
      }
    }
  },
  methods: {
    changeTaskType () {
      const resetTask = () => {
        this.taskTypeId = null
        this.majorTask = null
        this.middleTask = null
        this.minorTask = null
        this.updateTicketListOption(OptionType.MAJOR_TASK, this.majorTask)
        this.updateTicketListOption(OptionType.MIDDLE_TASK, this.middleTask)
        this.updateTicketListOption(OptionType.MINOR_TASK, this.minorTask)
        this.updateTicketListOption(OptionType.TASK_AUTO, this.taskAuto)
        this.$eventBus.$emit(eventType.UNSELECT_TASK_TYPE)
      }
      if (!this.initTicketList) {
        this.initTicketList = true
        this.taskAuto = !this.taskAuto
        resetTask()
        this.getTicketList(1, true)
      }
    },
    searchCounselTypes () {
      if (!this.currentTicketBrandId) {
        return false
      }
      this.$http({
        method: 'GET',
        url: `/gateway/ticket/task-types`,
        params: {
          ticketBrandId: this.currentTicketBrandId
        }
      })
        .then((result) => {
          try {
            if (result.data.code === 0) {
              this.brandCounselViewList = result.data.data
            } else {
              this.$alertMsg(result.data.message)
            }
          } catch (e) {
            console.log(e)
          }
        })
        .catch((err) => {
          if (err.response) {
            this.$alertMsg(err.response.data.message)
          }
        })
    },
    setBrandId () {
      this.brandId = this.currentBrandId ? this.currentBrandId : util.parseLoginToken().agentMappingBrandViews[0].brandId
    },
    checkPermission () {
      this.keyList.map(item => {
        this.isPermission[item] = permissions.checkAction(this.pmsKey[item])
      })
    },
    checkDate () {
      let diffDay = this.$moment.duration(this.$moment(this.endDate + ' 00:00').diff(this.$moment(this.startDate + ' 00:00'))).asDays()
      if (this.endDate === this.$moment(new Date()).format('YYYY-MM-DD')) {
        this.dateBtn = diffDay === 31 ? '30' : diffDay.toString()
      } else {
        this.dateBtn = -1
      }
    },
    getCurrentTicketBrandId () {
      return this.currentTicketBrandId ? this.currentTicketBrandId : 0
    },
    ticketNumberChange (number) {
      this.onPageSizeChanged(number)
    },
    validateExcelDownload () {
      this.$eventBus.$emit('excelPasswordDialog', {useDialog: true, currentBrandId: util.getUserBrandId()})
    },
    makeExcelFile (response) {
      let link = document.createElement('a')
      const url = response.data.url
      if (url) {
        link.href = url
        link.target = '_self'
        link.click()
      } else {
        this.$alertMsg('Excelのエクスポートエラー')
      }
      this.isExcelDownloading = false
    },
    paramsSerializer (paramObj) {
      const params = new URLSearchParams()
      for (const key in paramObj) {
        params.append(key, paramObj[key])
      }
      return params.toString()
    },
    searchParam (param) {
      return Array.isArray(param) ? param.join(',') : param
    },
    excelDownload () {
      if (this.endDate && this.startDate) {
        if (TicketListUtil.getExcelDownloadTimeLimitOverFlow(this.startDate, this.endDate)) {
          this.isExcelDownloading = true
          let ticketKeyword = this.ticketKeyword ? encodeURIComponent(this.ticketKeyword) : ''
          let customerKeyword = this.customerKeyword ? encodeURIComponent(this.customerKeyword) : ''

          const params = {
            brandId: this.brandId,
            startDate: this.startDate || null,
            endDate: this.endDate || null,
            ticketAgentIds: this.searchParam(this.showAgentIds) || null,
            taskTypeId: this.taskAuto ? TicketListUtil.getLeafTaskType(this.majorTask, this.middleTask, this.minorTask) : this.taskTypeId,
            channelId: this.selectedService || null,
            excelComment: this.excel.excelComment,
            password: this.excel.password ? this.excel.password : null
          }

          this.axios({
            method: 'get',
            url: `/api/ticketExternal/list/all/excel?` +
              `${TicketListUtil.listIntoGetParams('ticketIncomingChannels', this.incomingSelected)}` +
              `${TicketListUtil.listIntoGetParams('ticketPriorities', this.prioritySelected)}` +
              `${TicketListUtil.listIntoGetParams('ticketStatuses', this.statusSelected)}` +
              `${TicketListUtil.listIntoGetParams('selectedTags', this.selectedTags)}` +
              `&ticketKeyword=${ticketKeyword}` +
              `&customerKeyword=${customerKeyword}`,
            params
          }).then((res) => {
            if (res.data.code !== 0) {
              throw res.data.message
            } else {
              this.makeExcelFile(res.data)
            }
          })
        } else {
          this.$alertMsg('Excelのエクスポートは最大90日までエクスポートできます。')
        }
      } else {
        this.$alertMsg('Excelのエクスポートは期間を設定する必要があります。 (最大90日)')
      }
    },
    getTicketList (page, reset, order, ascending) {
      if (this.isLoading === true) return
      this.isLoading = true

      if (order !== undefined && ascending !== undefined) {
        this.order = order
        this.ascending = ascending
        this.datas = []
      }

      if (this.type === PageType.MY_PAGE) {
        this.agentSelectable = false
        this.getPageList()
      } else if (this.type === PageType.ALL_PAGE) {
        // [전체 티켓] 메뉴에 한하여 엑셀 다운로드 기능을 활성화 한다.
        this.excelButtonDisabled = false
        this.getPageList()
      } else if (this.type === PageType.COMPLETED_PAGE) {
        this.getPageList()
      } else {
        console.log('ERROR!!')
      }
      if (reset) {
        this.pagination.page = 1
      }
    },
    callAllTicketList (page, reset, order, ascending) {
      if (this.isLoading === true) return
      this.isLoading = true

      if (order !== undefined && ascending !== undefined) {
        this.order = order
        this.ascending = ascending
        this.datas = []
      }

      if (this.type === PageType.MY_PAGE) {
        this.agentSelectable = false
        this.callMyPageList(page)
      } else if (this.type === PageType.ALL_PAGE) {
        // [전체 티켓] 메뉴에 한하여 엑셀 다운로드 기능을 활성화 한다.
        this.excelButtonDisabled = false
        this.callAllPageList(page)
      } else if (this.type === PageType.COMPLETED_PAGE) {
        this.callAllPageList(page)
      } else {
        console.log('ERROR!!')
      }
      if (reset) {
        this.pagination.page = 1
      }
    },
    getPageList () {
      if (this.type === PageType.MY_PAGE) {
        this.callMyPageList(1)
      } else if (this.type === PageType.ALL_PAGE) {
        this.callAllPageList(1)
      }
    },
    callAllPageList (page) {
      this.ticketRefresh = false
      let ticketKeyword = this.ticketKeyword ? encodeURIComponent(this.ticketKeyword) : ''
      let customerKeyword = this.customerKeyword ? encodeURIComponent(this.customerKeyword) : ''
      this.axios.get(`/api/ticketExternal/list/all?` +
          `ticketKeyword=${ticketKeyword}` +
          `&customerKeyword=${customerKeyword}&` +
          `${TicketListUtil.listIntoGetParams('ticketIncomingChannels', this.incomingSelected)}` +
          `${TicketListUtil.listIntoGetParams('ticketPriorities', this.prioritySelected)}` +
          `${TicketListUtil.listIntoGetParams('ticketStatuses', this.statusSelected)}` +
          `${TicketListUtil.listIntoGetParams('selectedTags', this.selectedTags)}` +
          (this.showAgentIds.length !== 0 ? `${TicketListUtil.listIntoGetParams('agentIds', this.showAgentIds)}` : ''), {
        params: {
          brandId: this.brandId,
          ticketBrandId: this.currentTicketBrandId,
          page: page || 1,
          size: this.ticketSize,
          startDate: this.startDate ? this.startDate : null,
          endDate: this.endDate ? this.endDate : null,
          taskTypeId: this.taskAuto ? TicketListUtil.getLeafTaskType(this.majorTask, this.middleTask, this.minorTask) : this.taskTypeId,
          channelId: this.selectedService,
          order: this.order,
          ascending: this.ascending
        }
      }).then((res) => {
        this.errorCode = res.data.code
        this.ticketRefresh = true
        this.initTicketList = false
        this.isLoading = false
        if (this.errorCode !== 0) {
          if (this.errorCode === -500) {
            this.$ga.event({
              eventCategory: `チケット > チケット一覧`,
              eventAction: `500 ERROR`
            })
            return false
          }
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: `<dl class="txt"><dd>${res.data.message}</dd></dl>`
          })
        }
        this.generatePrettyDatas(res.data.data)
        this.pagination.totalItems = res.data.totalElements
        this.pagination.totalPages = res.data.totalPages
      }).catch((e) => {
        this.isLoading = false
      })
    },
    callMyPageList (page) {
      if (!this.currentTicketBrandId) {
        return false
      }
      let ticketKeyword = this.ticketKeyword ? encodeURIComponent(this.ticketKeyword) : ''
      let customerKeyword = this.customerKeyword ? encodeURIComponent(this.customerKeyword) : ''
      this.axios.get(`/api/ticketExternal/list/agent?` +
          `${TicketListUtil.listIntoGetParams('ticketIncomingChannels', this.incomingSelected)}` +
          `${TicketListUtil.listIntoGetParams('ticketPriorities', this.prioritySelected)}` +
          `${TicketListUtil.listIntoGetParams('ticketStatuses', this.statusSelected)}` +
          `${TicketListUtil.listIntoGetParams('selectedTags', this.selectedTags)}` +
          `&ticketKeyword=${ticketKeyword}` +
          `&customerKeyword=${customerKeyword}`, {
        params: {
          brandId: this.brandId,
          ticketBrandId: this.currentTicketBrandId,
          agentId: this.ticketAgentId,
          page: page || 1,
          size: this.ticketSize,
          startDate: this.startDate ? this.startDate : null,
          endDate: this.endDate ? this.endDate : null,
          taskTypeId: this.taskAuto ? TicketListUtil.getLeafTaskType(this.majorTask, this.middleTask, this.minorTask) : this.taskTypeId,
          channelId: this.selectedService,
          order: this.order,
          ascending: this.ascending
        }
      }).then((res) => {
        this.errorCode = res.data.code
        this.ticketRefresh = true
        this.isLoading = false
        this.initTicketList = false
        if (this.errorCode !== 0) {
          if (this.errorCode === -500) {
            this.$ga.event({
              eventCategory: `チケット > 担当チケット`,
              eventAction: `500 ERROR`
            })
            return false
          }
          this.$eventBus.$emit('DialogPopup', {
            useDialog: true,
            messageHTML: `<dl class="txt"><dd>${res.data.message}</dd></dl>`
          })
        }
        this.generatePrettyDatas(res.data.data)
        this.pagination.totalItems = res.data.totalElements
        this.pagination.totalPages = res.data.totalPages
      }).catch((e) => {
        this.isLoading = false
      })
    },
    generatePrettyDatas (data) {
      this.datas = []
      if (data) {
        data.forEach(item => {
          // 제목은 최대 40자 제한.
          item.subject = helper.textTruncate(item.subject, 40)
          // 메모가 존재할 경우, 목록에서 최대 20자 제한.
          // if (item.memo) {
          //   item.memo = helper.textTruncate(item.memo, 20)
          // }
          // 요청시간 변환
          if (item.createDate) {
            item.createDate = helper.convertCreateDateToYYYYMMDDhhmmss(item.createDate)
          }
          // 업데이트일자 변환
          if (item.modifyDate) {
            item.modifyDate = helper.convertCreateDateToYYYYMMDDhhmmss(item.modifyDate)
          }
          item.tags = this.convertTagsText(item.tags)
          this.datas.push(item)
        })
        this.isLoading = false
      }
    },
    updateOption (type, data) {
      if (type === 'income') {
        this.incomingSelected = data
      } else if (type === 'status') {
        this.statusSelected = data
      } else if (type === 'priority') {
        this.prioritySelected = data
      } else if (type === 'ticketSearch') {
        this.ticketKeyword = data
      } else if (type === 'customerSearch') {
        this.customerKeyword = data
      } else if (type === 'service') {
        this.selectedService = data
      } else if (type === 'search') {
      } else {
        console.error('エラー')
      }
      this.callAllTicketList(1, true)
      this.updateTicketListOption(type, data)
    },
    onCheckBoxChanged (arr) {
      this.selectedTicket = arr
    },
    onPressMergeButton () {
      this.mergeTicketDialogOpen = true
    },
    closeMergeDialog () {
      this.mergeTicketDialogOpen = false
    },
    // changStartData (amount, unit) {
    //   this.endDate = this.$moment(new Date()).format('YYYY-MM-DD')
    //   this.startDate = this.$moment(this.endDate).add(amount, unit).format('YYYY-MM-DD')
    //   this.updateDate(this.startDate, this.endDate)
    // },
    changStartData (day, type) {
      if (type === 'ALL') {
        this.startDate = ''
        this.endDate = ''
      } else {
        const now = this.$moment(new Date()).format('YYYY-MM-DD')
        if (day === 0 && type === 'days') {
          this.startDate = moment(now).subtract(day, type).format('YYYY-MM-DD')
        } else if (type === 'days') {
          this.startDate = moment(now).subtract(day, type).add(1, 'days').format('YYYY-MM-DD')
        } else {
          this.startDate = moment(now).subtract(day, type).format('YYYY-MM-DD')
        }
        this.endDate = moment(now).format('YYYY-MM-DD')
      }
      this.updateDate(this.startDate, this.endDate)
    },
    updateDate (startDate, endDate) {
      this.startDate = startDate
      this.endDate = endDate
      this.verifyDateAndRefresh()
      this.updateTicketListOption('startDate', this.startDate)
      this.updateTicketListOption('endDate', this.endDate)
    },
    updateStartDate (date) {
      this.startDate = date
      this.verifyDateAndRefresh()
      this.updateTicketListOption('startDate', date)
    },
    updateEndDate (date) {
      this.endDate = date
      this.verifyDateAndRefresh()
      this.updateTicketListOption('endDate', date)
    },
    verifyDateAndRefresh () {
      if (this.currentTicketBrandId) {
        this.callAllTicketList(1, true)
      }
    },
    updateAgent (arr) {
      this.showAgentIds = arr
      this.verifyAgentAndRefresh()
      this.updateTicketListOption('agent', arr)
    },
    verifyAgentAndRefresh () {
      this.callAllTicketList(1, true)
    },
    onPageSizeChanged (page) {
      this.ticketSize = page
      this.pagination.page = 1
      this.callAllTicketList()
      this.updateTicketListOption('pageSize', page)
    },
    updateSelectedTags (tags, data) {
      this.selectedTags = tags
      this.callAllTicketList()
      this.updateTicketListOption('tag', data)
    },
    openHeaderCustomizeDialog () {
      this.isHeaderCustomizeDialogOpen = true
    },
    updateHeader (arr) {
      this.headers = arr
    },
    updateMajorTaskType (type) {
      this.majorTask = type
      this.middleTask = null
      this.minorTask = null
      this.callAllTicketList(1, true)
      this.updateTicketListOption('majorTask', type !== undefined ? type : null)
      this.updateTicketListOption('middleTask', null)
      this.updateTicketListOption('minorTask', null)
    },
    updateMiddleTaskType (type) {
      this.middleTask = type
      this.minorTask = null
      this.callAllTicketList(1, true)
      this.updateTicketListOption('middleTask', type)
      this.updateTicketListOption('minorTask', null)
    },
    updateMinorTaskType (type) {
      this.minorTask = type
      this.callAllTicketList(1, true)
      this.updateTicketListOption('minorTask', type)
    },
    resetAllOptions () {
      this.isLoading = false
      this.incomingSelected = []
      this.selectedTicket = []
      this.statusSelected = this.disableOption === 'status' ? ['RESOLVED'] : []
      this.prioritySelected = []
      this.taskTypeId = null
      this.majorTask = null
      this.middleTask = null
      this.minorTask = null
      this.showAgentIds = []
      this.selectedTags = []
      this.ticketKeyword = null
      this.customerKeyword = ''
      this.selectedService = null
      this.order = 'modifyDate'
      this.ascending = false
      this.changStartData('-1', 'ALL')
      this.$refs.ticketCheckChannel.resetAll()
      this.$refs.ticketCheckStatus.resetAll()
      this.$refs.ticketCheckFirst.resetAll()
      this.$refs.ticketCounselTypeRef.resetAll()
      this.$refs.agentSelectRef.resetAll()
      this.$refs.tagSearchAutoCompleteRef.resetAll()
      this.$refs.searchTicketKeywordRef.resetAll()
      this.$refs.searchCustomerKeywordRef.resetAll()
      this.$refs.ticketShowListRef.resetSelected()
      this.$refs.ticketCounselTypeRef.callMajorTaskType()
      if (this.callMode === 'KT') {
        this.$refs.ticketServiceSelectRef.resetAll()
      }
      this.updateTicketListOption(OptionType.INCOME, this.incomingSelected)
      this.updateTicketListOption(OptionType.STATUS, this.statusSelected)
      this.updateTicketListOption(OptionType.PRIORITY, this.prioritySelected)
      this.updateTicketListOption(OptionType.MAJOR_TASK, this.majorTask)
      this.updateTicketListOption(OptionType.MIDDLE_TASK, this.middleTask)
      this.updateTicketListOption(OptionType.MINOR_TASK, this.minorTask)
      this.updateTicketListOption(OptionType.AGENT, this.showAgentIds)
      this.updateTicketListOption(OptionType.TAG, this.selectedTags)
      this.updateTicketListOption(OptionType.TICKET_SEARCH, this.ticketKeyword)
      this.updateTicketListOption(OptionType.CUSTOMER_SEARCH, this.customerKeyword)
      this.updateTicketListOption(OptionType.SERVICE_ID, this.selectedService)
      this.updateTicketListOption(OptionType.ORDER, this.order)
      this.updateTicketListOption(OptionType.ASCENDING, this.ascending)
      this.callAllTicketList(1, true)
    },
    convertTagsText (tags) {
      let text = ''
      tags.forEach(tag => {
        text += tag.text + ', '
      })
      text = text.slice(0, text.length - 2)
      return text
    },
    setTicketListOption () {
      const key = 'TICKET_LIST_OPTION'
      const option = localStorage.getItem(key)

      if (!option) {
        let startDate = ''
        let recentStartDate = moment(new Date(), 'YYYYMMDD').add(-6, 'days').format('YYYY-MM-DD')
        let endDate = ''

        localStorage.setItem(key, JSON.stringify(
          {
            myPage: {income: [], status: [], priority: [], startDate: startDate, endDate: endDate, majorTask: null, middleTask: null, minorTask: null, agent: [], tag: [], ticketSearch: null, customerSearch: null, selectedService: null, pageSize: 15, order: 'modifyDate', ascending: false},
            allPage: {income: [], status: [], priority: [], startDate: startDate, endDate: endDate, majorTask: null, middleTask: null, minorTask: null, agent: [], tag: [], ticketSearch: null, customerSearch: null, selectedService: null, pageSize: 15, order: 'modifyDate', ascending: false},
            recentUpdatedPage: {income: [], status: [], priority: [], startDate: recentStartDate, endDate: endDate, majorTask: null, middleTask: null, minorTask: null, agent: [], tag: [], ticketSearch: null, customerSearch: null, pageSize: 15, order: 'modifyDate', ascending: false},
            completedPage: {income: [], status: [], priority: [], startDate: startDate, endDate: endDate, majorTask: null, middleTask: null, minorTask: null, agent: [], tag: [], ticketSearch: null, customerSearch: null, pageSize: 15, order: 'modifyDate', ascending: false}
          }
        ))
      }
    },
    updateTicketListOption (type, data) {
      const key = 'TICKET_LIST_OPTION'
      const page = this.type
      const jsonArr = JSON.parse(localStorage.getItem(key))
      let option = {}

      if (jsonArr !== undefined) {
        option = TicketListUtil.parseJsonIntoPage(page, jsonArr)
        option[type] = data
      }

      localStorage.setItem(key, TicketListUtil.parseOptionIntoJson(page, jsonArr, option))
    },
    setTicketListOptionData () {
      const key = 'TICKET_LIST_OPTION'
      if (!localStorage.getItem(key)) {
        return false
      }
      const page = this.type
      const tagData = TicketListUtil.parseJsonIntoOption(this.type, OptionType.TAG, localStorage.getItem(key))
      let tagTemp = []

      this.incomingSelected = TicketListUtil.parseJsonIntoOption(page, OptionType.INCOME, localStorage.getItem(key))
      this.statusSelected = TicketListUtil.parseJsonIntoOption(page, OptionType.STATUS, localStorage.getItem(key))
      this.prioritySelected = TicketListUtil.parseJsonIntoOption(page, OptionType.PRIORITY, localStorage.getItem(key))
      this.startDate = TicketListUtil.parseJsonIntoOption(page, OptionType.START_DATE, localStorage.getItem(key))
      this.endDate = TicketListUtil.parseJsonIntoOption(page, OptionType.END_DATE, localStorage.getItem(key))
      this.majorTask = TicketListUtil.parseJsonIntoOption(page, OptionType.MAJOR_TASK, localStorage.getItem(key))
      this.middleTask = TicketListUtil.parseJsonIntoOption(page, OptionType.MIDDLE_TASK, localStorage.getItem(key))
      this.minorTask = TicketListUtil.parseJsonIntoOption(page, OptionType.MINOR_TASK, localStorage.getItem(key))
      this.taskTypeId = TicketListUtil.parseJsonIntoOption(page, OptionType.TASK_TYPE_ID, localStorage.getItem(key))
      this.taskAuto = TicketListUtil.parseJsonIntoOption(page, OptionType.TASK_AUTO, localStorage.getItem(key))
      this.showAgentIds = TicketListUtil.parseJsonIntoOption(page, OptionType.AGENT, localStorage.getItem(key))
      this.ticketKeyword = TicketListUtil.parseJsonIntoOption(page, OptionType.TICKET_SEARCH, localStorage.getItem(key))
      this.customerKeyword = TicketListUtil.parseJsonIntoOption(page, OptionType.CUSTOMER_SEARCH, localStorage.getItem(key))
      this.selectedService = TicketListUtil.parseJsonIntoOption(page, OptionType.SERVICE_ID, localStorage.getItem(key))
      this.ticketSize = TicketListUtil.parseJsonIntoOption(page, OptionType.PAGE_SIZE, localStorage.getItem(key))
      this.order = TicketListUtil.parseJsonIntoOption(page, OptionType.ORDER, localStorage.getItem(key))
      this.ascending = TicketListUtil.parseJsonIntoOption(page, OptionType.ASCENDING, localStorage.getItem(key))

      tagData.forEach((item) => {
        tagTemp.push(item.id)
      })
      this.selectedTags = tagTemp
    },
    checkKtCall () {
      this.$http.get('/api/brand/isUsableModuleChannel', {
        params: {
          brandId: this.brandId,
          moduleName: 'CALL',
          channelName: 'KT_CALL'
        }
      }).then(result => {
        this.isServiceSelectable = result.data.code === 0
      }).catch(err => {
        this.$alertMsg(err)
      })
    }
  },
  computed: {
    ...mapGetters([
      'currentTicketBrandId',
      'ticketAgentId',
      'currentBrandId',
      'callMode',
      'isFuncLv1'
    ])
  },
  mounted () {
    // this.headers = JSON.parse(localStorage.getItem('TICKET_LIST_COLUMN'))
    eventBus.$on(eventType.FETCH_TICKET_BRAND, () => {
      this.callAllTicketList()
      if (this.callMode === 'KT') {
        this.checkKtCall()
      }
    })
  },
  destroyed () {
    eventBus.$off(eventType.FETCH_TICKET_BRAND)
    eventBus.$off('excelPasswordDialog')
  },
  created () {
    this.setTicketListOptionData()
    this.checkPermission()
    this.setBrandId()
    this.setTicketListOption()
    this.searchCounselTypes()

    if (localStorage.getItem('TICKET_LIST_COLUMN')) {
    } else {
      localStorage.setItem('TICKET_LIST_COLUMN', JSON.stringify(
        [
          {text: 'id', align: 'center', value: 'dispId', sortable: false, width: '20%'},
          {text: 'タイトル', align: 'center', value: 'subject', sortable: false, width: '30%'},
          {text: '要請者', align: 'center', value: 'customerName', sortable: false, width: '10%'},
          {text: '要請日', align: 'center', value: 'createDate', sortable: false, width: '10%'},
          {text: '優先順位', align: 'center', value: 'priority', sortable: false, width: '10%'},
          {text: '状態', align: 'center', value: 'status', sortable: false, width: '10%'},
          {text: '担当者', align: 'center', value: 'agentName', sortable: false, width: '10%'}
        ]
      ))
    }
  }
}
</script>

<style lang="scss">
  /*@import url("../../css/ticket_management.css");*/
  .ticketCon {
    position: relative;
    .flexTbl dl dd {
      padding-left: 12px;
      &.autoCompBox {
        >div {
          width: 100%;
        }
      }
    }
    .require-notice-text {
      text-align: right;
    }
    .ticketListCon {
      .v-table tbody tr[active] {
        background: transparent !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/layout/ticket_list_conatiner.vue